const StatisticCard = ({ icon, label, value, iconBackgroundColor }) => {
  return (
    <div className="rounded bg-secondary-background min-w-[230px] w-[100%] h-[100px] flex items-center p-4 xxl:min-w-[200px]">
      <div
        style={{ backgroundColor: iconBackgroundColor }}
        className="min-w-12 rounded-full h-12 w-12 flex justify-center items-center text-white"
      >
        {icon}
      </div>
      <div className="flex flex-col gap-1 ml-5 text-over-secondary-background ">
        <span className="text-base font-bold leading-5">{value}</span>
        <span className="text-xs">{label}</span>
      </div>
    </div>
  )
}

export default StatisticCard
